import { AssignedDomainsPane } from "./AssignedDomainsPane";
import { AvailablePoolPane } from "./AvailablePoolPane";
import { DomainSlotSummaryBar } from "./DomainSlotSummaryBar";


export const DomainSplitWorkspace = (props) => (
  <div className="mx-auto w-full max-w-[1700px] space-y-5" data-testid="domain-split-workspace">
    <DomainSlotSummaryBar limits={props.domainLimits} />
    <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-12">
      <div className="min-w-0 lg:col-span-7"><AssignedDomainsPane {...props} /></div>
      <div className="min-w-0 lg:col-span-5"><AvailablePoolPane domains={props.availableDomains} limits={props.domainLimits} selectingDomain={props.selectingDomain} onSelect={props.onSelect} /></div>
    </div>
  </div>
);